import { render, staticRenderFns } from "./organization-finding-detail.vue?vue&type=template&id=651624ca&scoped=true&"
import script from "./organization-finding-detail.vue?vue&type=script&lang=js&"
export * from "./organization-finding-detail.vue?vue&type=script&lang=js&"
import style0 from "./organization-finding-detail.vue?vue&type=style&index=0&id=651624ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651624ca",
  null
  
)

export default component.exports